import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { MysqlRanksEdge } from '../../../graphqlTypes'

const Container = styled.li`
  margin: 26px 0 0;
  padding: 0 7px;
  width: 50%;
  &:first-child {
    border-bottom: 1px solid ${({ theme }) => theme.palette.border.light};
    margin: 0;
    padding: 0 0 40px;
    width: 100%;
  }
`

const ProductInfoContainer = styled.div`
  color: ${({ theme }) => theme.palette.font.main};
  font-weight: bold;
  margin: 12px 0 0;
`

const Manufacturer = styled.p`
  font-size: 12px;
  margin: 0 0 4px;
`

const ProductName = styled.p`
  font-size: 14px;
`

const EmblemImage = styled.img`
  width: 80px;
  height: 80px;
`

const ProductContainer = styled.div`
  align-items: flex-start;
  display: block;
  margin: 0;
`

const ImageFrame = styled(Link)`
  display: block;
  margin: 0 auto;
  object-fit: contain;
  text-decoration: none;
  width: 220px;
  height: 220px;
`

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`

type Props = {
  rank: MysqlRanksEdge
}

export default function AwardItem({ rank }: Props) {
  const product = rank.node.products!

  return (
    <Container>
      <ProductContainer>
        <LazyLoadComponent>
          <EmblemImage
            alt={'ママリ口コミ大賞 入賞エンブレム画像'}
            src={`${product.fields!.emblemImageUrl}?auto=format&w=160&h=160`}
            decoding={'async'}
          />
        </LazyLoadComponent>
        <ImageFrame to={product.fields!.pagePath!}>
          <LazyLoadComponent>
            <Image
              alt={product.name!}
              src={`${product.fields!.imageUrl}?auto=format&fit=clip&w=440&h=440`}
              decoding={'async'}
            />
          </LazyLoadComponent>
        </ImageFrame>
        <ProductInfoContainer>
          {product.manufacturer && <Manufacturer>{product.manufacturer}</Manufacturer>}
          <ProductName>{product.name}</ProductName>
        </ProductInfoContainer>
      </ProductContainer>
    </Container>
  )
}
